import { Link } from 'react-router-dom'
import {
  getAnimeDetailsUrl,
  getAnimeImage,
} from '../../../services/util.service'
import { MinusIcon, ThreeDots, PlusIcon } from '../../ui/icons/shared'

export function WatchlistCardView({
  items,
  canEdit,
  onIncrement,
  onDecrement,
  onRemove,
  onOpenEdit,
}) {
  return (
    <div className="grid items-center justify-center grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 lg:gap-10">
      {items.map((item) => (
        <div
          key={item.anizone_id}
          className="flex flex-col w-full items-center relative"
        >
          {canEdit && (
            <button
              onClick={() => onOpenEdit(item)}
              className="absolute left-[-12px] rotate-90 top-2 bg-secondaryBackground p-2 z-20"
            >
              <ThreeDots />
            </button>
          )}

          <Link to={getAnimeDetailsUrl(item)} className="block w-full">
            <img
              src={getAnimeImage(item)}
              alt={item.title_english || item.title}
              className="w-full h-[320px] object-cover rounded"
            />
          </Link>

          <div className="w-full">
            <div className="flex flex-col gap-2 items-center text-center bg-secondaryBackground p-6 mt-[-20px] w-full">
              <Link to={getAnimeDetailsUrl(item)} className="block w-full">
                <p
                  className="text-white overflow-hidden whitespace-nowrap text-ellipsis max-w-full"
                  title={`${item.title_hebrew} // ${
                    item.title_english || item.title
                  }`}
                >
                  <span className="font-bold">{item.title_hebrew}</span>
                  <br />
                  <span className="text-muted">
                    {item.title_english || item.title}
                  </span>
                </p>
              </Link>

              <div className="flex gap-2 items-center">
                {canEdit ? (
                  <>
                    <button
                      onClick={() => onDecrement(item)}
                      className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                    >
                      <MinusIcon />
                    </button>
                    <span className="text-softText">
                      {item.episodes ?? '??'} /{' '}
                      <span className="text-primary">{item.progress}</span>
                    </span>
                    <button
                      onClick={() => onIncrement(item)}
                      className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                    >
                      <PlusIcon />
                    </button>
                  </>
                ) : (
                  <span className="text-softText">
                    {item.episodes ?? '??'} /{' '}
                    <span className="text-primary">{item.progress}</span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
